/**
 * DebugTracePanel — Collapsible execution trace timeline below agent messages
 */

import React, { useState } from 'react';
import { IconSearch, IconChevronDown, IconChevronRight } from '@tabler/icons-react';
import { computeDepth, formatDuration } from './DebugTraceUtils';
import DebugTraceEvent from './DebugTraceEvent';

const DebugTracePanel = ({ trace }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!trace || !trace.events || trace.events.length === 0) return null;

  const events = computeDepth(trace.events);
  const totalDuration = formatDuration(trace.total_duration_ms);
  const eventCount = events.length;

  // node_id → label  (eventos que já trazem node_id preenchido)
  // node_key → node_id  fallback para eventos filhos que chegam com node_id vazio
  const nodeLabels = {};
  const nodeKeyToId = {};
  trace.events.forEach((e) => {
    if (e.event_type === 'node.enter' && e.node_id && e.data?.node_label) {
      nodeLabels[e.node_id] = e.data.node_label;
      if (e.node_key) nodeKeyToId[e.node_key] = e.node_id;
    }
  });

  const resolveEvent = (e) => {
    const nodeId = e.node_id || nodeKeyToId[e.node_key] || null;
    const nodeLabel = nodeLabels[nodeId] || null;
    return { nodeId, nodeLabel };
  };

  return (
    <div className="debug-trace-panel">
      <div
        className="debug-trace-header"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <div className="debug-trace-header__left">
          {isExpanded ? <IconChevronDown size={14} /> : <IconChevronRight size={14} />}
          <IconSearch size={14} />
          <span className="debug-trace-header__title">Execution Trace</span>
          <span className="debug-trace-header__badge">
            {eventCount} evento{eventCount !== 1 ? 's' : ''}
          </span>
          {totalDuration && (
            <span className="debug-trace-header__duration">{totalDuration}</span>
          )}
        </div>
      </div>
      {isExpanded && (
        <div className="debug-trace-events">
          {events.map((event, index) => {
            const { nodeId, nodeLabel } = resolveEvent(event);
            return (
              <DebugTraceEvent
                key={index}
                event={event}
                nodeLabel={nodeLabel}
                resolvedNodeId={nodeId}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DebugTracePanel;
